module.exports = __webpack_public_path__ + "img/903B2A_EC9888_D96747_58190D-256px.a3dfecea.png";